<template>
    <div class="grid-container md:p-4">
        <div v-for="(student, index) in students" :key="index">
            <Card class="Card p-5 h-full relative">
                <template #content>
                    <!-- <div v-if="student.isRescheduleRequest" class="absolute top-0 right-0 m-2 py-1 px-2 text-xs font-semibold bg-teal-100 Label-teal border-1 border-green-300 border-round-md">
                        Reschedule
                    </div> -->
                    <div v-if="student.isRescheduleRequest"
                        class="absolute top-0 right-0 m-2 py-1 px-2 text-xs font-semibold bg-gray-50 text-gray-400 border-1 border-gray-300 border-round-md">
                        Reschedule
                    </div>
                    <div class="flex flex-column align-items-start justify-content-start gap-2 text-sm">

                        <div class="flex justify-content-start gap-2">
                            <Avatar
                                :image="student.profilePhotoURL ? profileImageUrl(student.profilePhotoURL) : blankProfile"
                                class="mr-2 flex-shrink-0" size="xlarge" shape="circle" />
                            <div class="flex flex-column justify-content-center gap-2 pb-2">
                                <span class="text-left Paragraph-Medium -mb-2 student-name">{{ student.student }}</span>
                                <span class="Caption"> {{ cleanupLables(student.grade) }}</span>
                            </div>
                        </div>

                        <div class="flex justify-content-start gap-2 pb-2">
                            <span class="Paragraph-Regular"> {{ cleanupLables(student.classModel) }}</span>
                        </div>

                        <div class="flex flex-wrap align-items-center justify-content-start gap-2">
                            <span class="flex subjects items-center justify-content-center px-2 py-2  Caption">
                                {{ Array.isArray(student.subject) ? student.subject.map(cleanupLables).join(', ') : cleanupLables(student.subject) }}
                            </span>
                        </div>

                        <div class="flex justify-content-start gap-2 pt-2">
                            <!-- <span class="Caption">Next class date: {{ formatToYYYYMMDD(student.date) }}</span> -->
                            <span class="Caption">Requested date: {{ formatToYYYYMMDD(student.created_at) }}</span>
                        </div>

                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-content-center gap-2 mt-3">
                        <Button label="View" class="teal-button-small" @click="handleViewRequest(student)" />
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from "vue";
import Card from "primevue/card";
import Button from "primevue/button";
import Avatar from "primevue/avatar";
import blankProfile from '@/assets/blank-profile.png';
import { cleanupLables } from "@/utils/cleanups";
import { generateSignedUrl } from '@/api/storage';

// --- UTILITY FUNCTION ---
const formatToYYYYMMDD = (dateValue) => {
    if (!dateValue) return 'N/A';

    // Check if the input is already a Date object or can be converted
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);

    // Check for invalid dates
    if (isNaN(date)) return dateValue;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}.${month}.${day}`;
};

// --- PROPS & EMITS ---
defineProps({
    students: {
        type: Array,
        required: true
    },
});

const emit = defineEmits(['view-request']);

const imageUrls = ref({});

const profileImageUrl = (filePath) => {
    if (imageUrls.value[filePath]) {
        return imageUrls.value[filePath];
    }

    generateSignedUrl(filePath)
        .then(url => {
            imageUrls.value[filePath] = url;
        })
        .catch(() => {
            imageUrls.value[filePath] = blankProfile;
        });

    return imageUrls.value[filePath] || blankProfile;
};

const handleViewRequest = (student) => {
    emit('view-request', student);
};
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    gap: 3rem;
}

.Card {
    /* background-color: var(--teal-800); */
    border-radius: 4px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.p-button-danger {
    padding: 10px 16px 10px 16px;
    height: 30px;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

.justify-content-center {
    justify-content: center;
}

.subjects {
    border: 1px solid var(--gray-700) !important;
    border-radius: 50px;
    background-color: transparent;
}

.student-name {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.Card :deep(.p-avatar.p-avatar-xl) {
    width: 4rem;
    height: 4rem;
    flex-shrink: 0;
}

.Card :deep(.p-avatar.p-avatar-xl img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>